export const LOT_CRITERION = {
  valuta: 'Валюта',
  payment: 'Условия оплаты',
  delivery: 'Условия доставки',
  delayMax: 'Максимальное значение отсрочки',
}
